import React from "react";

const Inputs = () => {
  return (
    <div className="bg-[#b0b0b0] h-screen">
      <div className="flex justify-center items-center">
        <h1 className="text-2xl font-bold">Inputs Page</h1>
      </div>
    </div>
  );
};

export default Inputs;
